import * as React from 'react';
import { useState } from 'react';
import { A11y, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import './style.scss';

const TabbedContent = props => {
  const [swiper, setSwiper] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  return (
    <div className="tabbed-content">
      <div className="tabs">
        {props.tabs.map((tab, i) => (
          <button
            key={i}
            className={`tab ${activeTabIndex === i ? 'is-active' : ''}`}
            onClick={() => {
              swiper.slideTo(i);
              setActiveTabIndex(i);
            }}
          >
            {tab.title}
          </button>
        ))}
      </div>

      <Swiper
        autoHeight
        modules={[Pagination, A11y]}
        pagination={{ clickable: true }}
        onSwiper={instance => setSwiper(instance)}
        onSlideChange={swiper => setActiveTabIndex(swiper.activeIndex)}
      >
        {props.tabs.map((tab, i) => (
          <SwiperSlide key={i}>
            <div className={`tab-content ${activeTabIndex === i ? 'is-active' : ''}`}>
              <h5 className="mob-title">{tab.title}</h5>
              {tab.content}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TabbedContent;
